let processLayout = function( input, maxHeight, maxWidth ) {
	let tree = [ {
		id: 'root',
		start: 0,
		end: maxHeight,
		depth: -1,
		children: [],
	} ];

	// Siblings container wrapper, for more performant BFT
	let siblingIndex = {
		index: {},

		clear: function() {
			this.index = {};
		},

		add: function( node ) {
			let level = this.index[ node.depth ] || ( this.index[ node.depth ] = [] );
			level.push( node );
		},

		get: function( depth ) {
			return this.index[ depth ] || [];
		}
	};

	// Add a new node to the tree, while maintaining siblings index
	function append( node, item, depth ) {
		item.depth = depth+1;
		siblingIndex.add( item );
		node.children.push( item );
		item.parent = node;
		tree.push( item );
	}

	// Predicate for checking if two events overlap
	function overlaps( node, item ) {
		/*eslint-disable */
		return ( item.start >= node.start && item.start < node.end )
				|| ( ( node.start == item.start ) || ( node.end == item.end ) );
		/*eslint-enable */
	}

	// returns true on successful tree placement
	function traverse( node, item, depth ) {
		if ( ! overlaps( node, item ) ) {
			return false;
		}

		// Run BFT on siblings to check if there are any overlaps
		let list = siblingIndex.get( depth + 1 );

		for ( let key in list ) {
			if ( traverse( list[ key ], item, depth + 1 ) ) {
				return true;
			}
		}

		// If there's an overlap, append the item under the current node
		append( node, item, depth );

		return true;
	}

	// Find max depth for each tree branch
	function setMaxDepth() {
		// Visit and set maxDepth on all of node's children
		let setChildren = function( node, depth ) {
			node.maxDepth = depth;
			node.children.forEach( function( child ) {
				setChildren( child, depth );
			} );
		};

		// Only need the leaves from the lookup table
		let leaves = tree.filter( function( node ) {
			return node.children.length === 0;
		} );

		// Visit every leaf, find maxDepth, reach root and update the roots (root index)
		let roots = {}, currentRoot;
		leaves.forEach( function( leaf ) {
			let node = leaf, maxDepth = 0;

			while ( 1 ) {
				maxDepth = Math.max( maxDepth, node.depth );

				if ( node.parent && node.parent.depth >= 0 ) {
					node = node.parent;
				} else {
					currentRoot = roots[ node.id ] || ( roots[ node.id ] = node );
					currentRoot.maxDepth = Math.max( currentRoot.maxDepth, maxDepth );
					break;
				}
			}
		} );

		// Traverse children (DFT)
		for ( let rootId in roots ) {
			setChildren( roots[ rootId ], roots[ rootId ].maxDepth );
		}
		tree.forEach( function( leaf ) {
			let nextDepth = leaf.maxDepth+1;
			let siblings  = siblingIndex.get( nextDepth );
			while ( siblings.length > 0 ) {
				for( let index in siblings ) {
					if ( overlaps( siblings[ index ], leaf ) ) {
						leaf.maxDepth = Math.max( leaf.maxDepth, siblings[ index ].maxDepth );
						return;
					}
				}
				siblings = siblingIndex.get( ++nextDepth );
			}
		} );
	}

	// Set widths for each node
	function setWidths() {

		// Calculate max depth first.
		setMaxDepth();

		// Then calculate and set width for each node
		tree.forEach( function( node ) {
			node.width = maxWidth / ( node.maxDepth+1 );
		} );
	}

	// Format lookup table for result
	// eslint-disable-next-line
	function format( tree ) {
		// eslint-disable-next-line
		return tree.map( function( node ) {
			return {
				id: node.id,
				top: node.start,
				left: node.width * node.depth,
				width: node.width,
				height: node.height
			};
		} );
	}

	siblingIndex.clear();

	// Fill in helpers.
	input = input.map( function( node ) {
		// Make sure height is at least 15 pixels. Otherwise, adjust `end`
		// for proper calculations to account for it.
		if ( ( node.end - node.start ) < 22 ) {
			node.end = node.start + 22;
		}

		return {
			id: node.id,
			start: node.start,
			end: node.end,
			height: node.end - node.start,
			width: 0,
			children: [],
			depth: 0,
			maxDepth: 0
		};
	} ).sort( function( a, b ) {
		// Sort by start time, then length
		return a.start === b.start ? b.end - a.end : a.start - b.start;
	} );

	let root = tree[0];

	input.forEach( function( item ) {
		traverse( root, item, -1 );
	} );

	setWidths();
	tree.shift();

	return tree.map( function( node ) {
		return {
			id: node.id,
			top: node.start,
			left: node.width * node.depth,
			width: node.width,
			height: node.height
		};
	} );
};

module.exports.processLayout = processLayout;
